/* eslint-disable react-hooks/exhaustive-deps */
import useApi, { GET_NOTES } from 'hooks/useApi';
import { useEffect, useState } from 'react';

export default (masterObjectId, pageSize = 10) => {
  const [notes, setNotes] = useState([]);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [isResetReady, setIsResetReady] = useState(false);

  const [state, sendRequest] = useApi();
  const { data, isLoading, isError } = state;

  const fetchNext = page => {
    if (!hasMorePages) {
      return;
    }
    const params = GET_NOTES({ masterObjectId, page, pageSize, searchText });
    sendRequest(params);
  };

  // Initiate state reset when search term has changed
  useEffect(() => {
    setNotes([]);
    setHasMorePages(true);
    setIsResetReady(true);
  }, [searchText]);

  // Search with updated term when state reset is complete
  useEffect(() => {
    if (!isResetReady) return;
    fetchNext(1);
    setIsResetReady(false);
  }, [isResetReady]);

  useEffect(() => {
    if (isLoading || isError) return;
    if (data) {
      const { notes: currentNotes } = data;
      if (currentNotes.length < pageSize) {
        setHasMorePages(false);
      }
      setNotes(prev => prev.concat(currentNotes));
    }
  }, [data, isError, isLoading, pageSize]);

  return [state, notes, fetchNext, searchText, setSearchText];
};
